import React from 'react';

const CSS = require('./ActionDialogFigure.module.scss');

export interface ActionDialogFigureProps {
  children: React.ReactNode;
  variant?: 'sandstone' | 'pink' | 'purple' | 'orange' | 'red' | 'green';
}

function ActionDialogFigure({
  children,
  variant = 'sandstone',
}: ActionDialogFigureProps) {
  return (
    <figure data-variant={variant} className={CSS.ActionDialogFigure}>
      {children}
    </figure>
  );
}

export default ActionDialogFigure;
